var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { PopupController } from "./PopupController";
import { observer } from "mobx-react";
import { PopupPortal, Overlay, Content, CloseButton } from "./components";
function getPopupDefaultConfig() {
    return {
        hasOverlay: true,
        popupPortalEl: window.document.body,
        className: "",
        hasCloseBtn: true
    };
}
var Popup = /** @class */ (function (_super) {
    __extends(Popup, _super);
    function Popup(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { controller: new PopupController(__assign({}, getPopupDefaultConfig(), props.config)) };
        _this.closeHandler = _this.state.controller.hide.bind(_this.state.controller);
        return _this;
    }
    Popup.prototype.componentDidMount = function () {
        this.state.controller.show();
    };
    Popup.prototype.componentWillUnmount = function () {
        this.state.controller.hide();
    };
    Popup.prototype.render = function () {
        var overlayClass = this.state.controller.config.hasOverlay ? "rj-popup-portal--hasOverlay" : "";
        var customClass = this.state.controller.setClassName;
        var closeBtnClass = this.state.controller.config.hasCloseBtn ? "rj-popup-message__hasCloseBtn " + customClass : customClass;
        return (this.state.controller.shouldShow &&
            React.createElement(PopupPortal, { popupPortalEl: this.state.controller.config.popupPortalEl, className: overlayClass + " " + this.state.controller.config.className },
                React.createElement(Overlay, { onTouchMove: this.state.controller.eventHandlers.mobileScrollHandling.preventScroll, onClick: this.state.controller.config.closeFromOverlay ? this.closeHandler : function () { } }),
                React.createElement(Content, { className: closeBtnClass, onTouchStart: this.state.controller.eventHandlers.mobileScrollHandling.touchStartHandler, onTouchMove: this.state.controller.eventHandlers.mobileScrollHandling.touchMoveHandler, top: this.state.controller.contentElTop[0] },
                    this.state.controller.config.hasCloseBtn && React.createElement(CloseButton, { onClick: this.closeHandler }),
                    this.props.children)));
    };
    Popup = __decorate([
        observer,
        __metadata("design:paramtypes", [Object])
    ], Popup);
    return Popup;
}(React.Component));
export { Popup };
//# sourceMappingURL=Popup.js.map